// # Copyright (C) 2025 All rights reserved.
// #
// # @File frappe_wxwork.bundle.js
// # @Brief 企业微信前端增强逻辑
// # @Author 杨嘉祥, vnimy@mediad.cn
// # @Version 1.0
// # @Date 2025-01-26
// #

frappe.provide('frappe_wxwork');

frappe_wxwork.is_wxwork_browser = function () {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('wxwork') || ua.includes('micromessenger');
};

frappe_wxwork.get_wxwork_oauth_url = function () {
  return frappe.call({
    method: 'frappe_wxwork.frappe_wxwork.doctype.wxwork_settings.wxwork_settings.get_oauth_url',
  }).then(r => {
    if (r.message && r.message.url) {
      return r.message.url;
    }
    return null;
  });
};

frappe_wxwork.enhance_login_page = function () {
  // 为企业微信登录按钮添加绿色样式和图标
  const wxwork_btn = $('.btn-wxwork-login, .social-login-button[href*="wxwork"], .social-login-button[href*="weixin"]');
  if (wxwork_btn.length) {
    wxwork_btn.addClass('wxwork-login-btn');
    wxwork_btn.each(function () {
      const $btn = $(this);
      if (!$btn.find('.wxwork-icon').length) {
        $btn.prepend('<span class="wxwork-icon"><svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" style="vertical-align: middle; margin-right: 6px;"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.133 0 .241-.11.241-.245 0-.06-.023-.118-.039-.177l-.326-1.233a.492.492 0 01.177-.554C23.028 18.558 24 16.803 24 14.861c0-3.252-2.83-5.94-7.062-6.003zm-2.745 2.981c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.842 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982z"/></svg></span>');
      }
    });
  }
};

frappe_wxwork.auto_redirect_in_wxwork = function () {
  // 在企微/微信浏览器中自动跳转网页授权
  if (frappe_wxwork.is_wxwork_browser()) {
    frappe_wxwork.get_wxwork_oauth_url().then(url => {
      if (url) {
        window.location.href = url;
      }
    });
  }
};

// 监听登录页面渲染事件
$(document).on('login_rendered', function () {
  frappe_wxwork.enhance_login_page();
  frappe_wxwork.auto_redirect_in_wxwork();
});
